import {useState} from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useQuery } from 'customHooks';

import { useGet, usePost } from 'customHooks/api';

export const QueryKeys = {
  CONFIGURACOES: 'configuracoes',
  RELATORIO: 'relatorio_aluguel'
};

export const useGetConfiguracoes = () => {
  const getConfiguracoes = useGet('configuracoes');
  return useQuery([QueryKeys.CONFIGURACOES], getConfiguracoes);
};

export const usePostConfiguracoes = () => {
  const queryClient = useQueryClient();
  const postConfiguracoes = usePost('configuracoes');
  return useMutation(postConfiguracoes, {
    onSuccess: data => queryClient.setQueryData([QueryKeys.CONFIGURACOES], data)
  });
};

export const usePostRelatorio = (id, queryConfig) => {
  const post = usePost(`dados.xlsx`);
  return useMutation(post, queryConfig);
};

export const useGetRelatorio = (path = 'dados.xlsx', queryConfig) => {
  const getRelatorio = useGet(path, {
    responseType: 'blob'
  });
  return useQuery(
    [QueryKeys.RELATORIO, path],
    getRelatorio,
    queryConfig
  );
};

export const useDownloadRelatorio = (path = 'dados.xlsx', filename = 'relatorio.xlsx') => {
  const [isFetching, setFetching] = useState(false);
  const { refetch: recuperarRelatorio } = useGetRelatorio(path, {
    enabled: false,
  });

  const fetch = async () => {
    try {
      setFetching(true);
      const res = await recuperarRelatorio();

      const url = URL.createObjectURL(res.data.data);
      const element = document.createElement('a');
      setFetching(false);

      element.setAttribute('href', url);
      element.setAttribute('download', filename);
      element.setAttribute('target', '_blank');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (er) {
      setFetching(false);
      throw er;
    }
  };

  return [fetch, { isFetching }];
};
